import {
	hasAuthTelemetryFired,
	markAuthTelemetryFired,
} from "~/tooling/session/auth-telemetry-client-state";
import type { PendingAuthTelemetry } from "~/tooling/session/consume-pending-auth-telemetry";
import { captureEvent, trackEvent } from "~/tooling/telemetry/capture-event";
import {
	createLoginEvent,
	userRegisteredEvent,
} from "~/tooling/telemetry/events";

export function fireAuthTelemetryEvents(
	pendingAuthTelemetry?: PendingAuthTelemetry | null,
	authTelemetryId?: string | null,
): void {
	if (!pendingAuthTelemetry) {
		return;
	}
	if (authTelemetryId && hasAuthTelemetryFired(authTelemetryId)) {
		return;
	}
	// Intentionally no else: new users emit Registered then Logged In.
	// Returning users only emit Logged In.
	if (pendingAuthTelemetry === "register") {
		captureEvent(userRegisteredEvent());
		trackEvent("register");
	}
	captureEvent(createLoginEvent());
	trackEvent("log_in");
	if (authTelemetryId) {
		markAuthTelemetryFired(authTelemetryId);
	}
}
